/** Matches mobile-first breakpoints used by StickyComponentWrapper (`baseVariables.mediaQuery`). */
const VIEWPORT_SM = 576;
const VIEWPORT_MD = 768;
const VIEWPORT_LG = 992;

const nonStickyTopByBreakpoint = {
  xs: {
    BAU: { HTLHeader: 112, globalNav: 52 },
    polaris: { HTLHeader: 128, globalNav: 136 },
  },
  sm: {
    BAU: { HTLHeader: 112, globalNav: 88 },
    polaris: { HTLHeader: 128, globalNav: 136 },
  },
  md: {
    BAU: { HTLHeader: 112, globalNav: 88 },
    polaris: { HTLHeader: 168, globalNav: 176 },
  },
  lg: {
    BAU: { HTLHeader: 112, globalNav: 88 },
    polaris: { HTLHeader: 200, globalNav: 208 },
  },
} as const;

export type StickySearchFormBreakpoint = keyof typeof nonStickyTopByBreakpoint;

export function getStickySearchFormLayoutBreakpoint(): StickySearchFormBreakpoint {
  if (typeof window === 'undefined') {
    return 'xs';
  }
  const w = window.innerWidth;
  if (w >= VIEWPORT_LG) {
    return 'lg';
  }
  if (w >= VIEWPORT_MD) {
    return 'md';
  }
  if (w >= VIEWPORT_SM) {
    return 'sm';
  }
  return 'xs';
}

export function getNonStickyTop(
  breakpoint: StickySearchFormBreakpoint,
  isNorthStar?: boolean,
  hasGlobalNav?: boolean
): number {
  const variant = isNorthStar ? 'polaris' : 'BAU';
  const headerType = hasGlobalNav ? 'globalNav' : 'HTLHeader';
  return nonStickyTopByBreakpoint[breakpoint][variant][headerType];
}
